import { AfterViewInit, Component, OnInit, Injector, Optional, AfterContentInit } from "@angular/core";

import {
  BaseComponent,
  provideAsWidgetRef,
  IWidgetConfig,
  Parent,
  register,
  styler,
  ImagePipe, StylableComponent
} from '@wm/components-base';
import {CommonModule} from "@angular/common";

const DEFAULT_CLS = 'app-header app-mobile-navbar';
const WIDGET_CONFIG: IWidgetConfig = {widgetType: 'wm-mobile-navbar', hostClass: DEFAULT_CLS};

@Component({
  selector: 'header[wmMobileNavbar]',
  templateUrl: './mobile-navbar.component.html',
  imports: [CommonModule, ImagePipe],
  providers: [
    provideAsWidgetRef(MobileNavbarComponent)
  ],
  standalone: true,
  exportAs: 'wmMobileNavbar'
})
export class MobileNavbarComponent extends StylableComponent implements OnInit, AfterViewInit {
  static initializeProps = register('wm-mobile-navbar');

  showSearchbar: boolean;
  leftNavPanel: any;
  showLeftnav: boolean;
  backbuttoniconclass: any;
  backbuttonlabel: string = '';
  backbutton: any;
  leftnavpaneliconclass: any;

  searchbuttoniconclass: any;
  searchbuttonlabel: any;
  searchbutton: any;
  title: string;
  imgsrc: string;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }


  ngAfterContentInit() {

    let leftPanel = this.$element.closest('[wmPage]').find('.app-left-panel:first')

    if (leftPanel.length) {
      this.leftNavPanel = leftPanel[0].widget
      if (this.leftNavPanel) {
        this.showLeftnav = this.$attrs.get('showLeftnav') !== 'false';
      }
    }
  }


}
